/**
 * Textos del kit, en español. Son los mismos que hoy muestra DevExtreme (localización `es`) en
 * las pantallas del BackOffice, para que el reemplazo no cambie lo que se lee ni lo que anuncia un
 * lector de pantalla.
 */
export const UI_TEXT = {
  close: 'Cerrar',
  yes: 'Sí',
  no: 'No',
  ok: 'Aceptar',
  cancel: 'Cancelar',
  select: 'Seleccionar...',
  selectButton: 'Seleccionar',
  selectAll: 'Seleccionar Todo',
  selectRow: 'Seleccionar fila',
  clear: 'Limpiar',
  increase: 'Aumentar',
  decrease: 'Disminuir',
  openCalendar: 'Abrir calendario',
  search: 'Buscar...',
  searchGrid: 'Buscar en la tabla de datos',
  empty: 'Sin datos para mostrar',
  loading: 'Cargando...',
  collapse: 'Colapsar',
  expand: 'Expandir',
  groupPanel: 'Arrastra una columna aquí para agrupar por ella',
  groupByColumn: 'Agrupar por esta columna',
  ungroup: 'Desagrupar',
  ungroupAll: 'Desagrupar Todo',
  filterOptions: 'Opciones de filtro',
  filterButton: (caption: string) => `Mostrar opciones de filtro para la columna '${caption}'`,
  emptyValue: '(Vacío)',
  previousPage: 'Página anterior',
  nextPage: 'Página siguiente',
  page: (page: number) => `Página ${page}`,
  pager: 'Navegación de páginas',
  sortAscending: 'Orden Ascendente',
  sortDescending: 'Orden Descendente',
  clearSorting: 'Limpiar Ordenamiento',
  moveLeft: 'Mover a la izquierda',
  moveRight: 'Mover a la derecha',
  sortedAscending: 'Columna ordenada en orden ascendente',
  sortedDescending: 'Columna ordenada en orden descendente',
  refresh: 'Actualizar',
  retry: 'Reintentar',
  loadError: 'No se pudieron cargar los datos.',
  toolbar: 'Barra de herramientas de la tabla de datos',
  detailCell: 'Celda con detalles',
  column: (caption: string) => `Columna ${caption}`,
  grid: (rows: number, columns: number) => `Tabla de datos con ${rows} filas y ${columns} columnas`,
} as const;
